import api from "./index";
import { getREAProperties, getREAProperty, createREAProperty, updateREAProperty, deleteREAProperty } from "./rea";

// Fetch all Collings properties (wraps REA properties)
export const getCollingsProperties = (params) => {
    return getREAProperties(params);
};

// Fetch a single Collings property by ID
export const getCollingsProperty = (id) => {
    return getREAProperty(id);
};

// Import a property (uses createREAProperty)
export const importCollingsProperty = (data) => {
    return createREAProperty(data);
};

// Update an imported property (uses updateREAProperty)
export const updateCollingsProperty = (id, data) => {
    return updateREAProperty(id, data);
};

// Delete a property (uses deleteREAProperty)
export const deleteCollingsProperty = (id) => {
    return deleteREAProperty(id);
};

// Patch a property (partial update for archive/unarchive)
export const patchCollingsProperty = (id, data) => {
    const { patchREAProperty } = require('./rea');
    return patchREAProperty(id, data);
};

// REA Publishing functions for Collings properties
export const publishCollingsPropertyToREA = (propertyId) => {
    const { publishCollingsPropertyToREA } = require('./rea');
    return publishCollingsPropertyToREA(propertyId);
};

export const unpublishCollingsPropertyFromREA = (propertyId) => {
    const { unpublishCollingsPropertyFromREA } = require('./rea');
    return unpublishCollingsPropertyFromREA(propertyId);
};

export const previewCollingsREAXML = (propertyId) => {
    const { previewCollingsREAXML } = require('./rea');
    return previewCollingsREAXML(propertyId);
};

// Trash: list soft-deleted properties
export const getTrashedCollingsProperties = () => {
    return api.get('property-crawler/real-estate-properties/trash/');
};

// Restore a soft-deleted property from trash
export const restoreCollingsProperty = (id) => {
    return api.post(`property-crawler/real-estate-properties/${id}/restore/`);
};

// Reorder images for a Collings property (lightweight endpoint)
export const reorderCollingsPropertyImages = (id, images) => {
    const { reorderREAPropertyImages } = require('./rea');
    return reorderREAPropertyImages(id, images);
};

// Floorplan tagging (separate from the regular Images gallery, max 2 - REA's own limit)
export const uploadCollingsPropertyFloorplan = (id, files) => {
    const { uploadREAPropertyFloorplan } = require('./rea');
    return uploadREAPropertyFloorplan(id, files);
};

export const deleteCollingsPropertyFloorplan = (id, floorplanImageIds) => {
    const { deleteREAPropertyFloorplan } = require('./rea');
    return deleteREAPropertyFloorplan(id, floorplanImageIds);
};
